import { render, staticRenderFns } from "./JSON.vue?vue&type=template&id=4b6b866c&"
import script from "./JSON.vue?vue&type=script&lang=js&"
export * from "./JSON.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports